export const PRODUCT_PAGE_ROUTE = '(?<productCode>[a-z\\-0-9_]+)-(?<productId>[0-9]+)';

export const PRODUCT_PAGE_SHORT_ROUTE = '-[0-9]+';
